import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

const Waveform = ({ track }) => {

  const theme = useTheme();

  // State for the sample data
  const [sampleData, setSampleData] = useState(null);

  // Fetch the waveform JSON data
  useEffect(() => {
    const fetchWaveform = async () => {
      try {
        const url = `https://media.tracktribe.com/${track.track_type}/waveforms/${track.title}_waveform.json`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Failed to fetch waveform data: ${response.statusText}`);
        }

        const data = await response.json();
        setSampleData(data);
      } catch (error) {
        console.error("Error fetching waveform data:", error);
      }
    };

    fetchWaveform();
  }, [track]);

  const canvasRef = useRef(null);

  useEffect(() => {
    if (!sampleData) return; // Do not proceed until sample data is loaded

    const { samples } = sampleData;
    const height = 60;
    const color = theme.palette.primary.main;
    const barWidth = 3;

    const canvas = canvasRef.current;
    // const parent = canvas.parentElement; // Get the parent container
    const width = 600;
    // const width = parent.offsetWidth; // Dynamically set the canvas width to parent width
    const clampedHeight = Math.max(50, Math.min(height, 60));

    canvas.width = width;
    canvas.height = clampedHeight;

    const ctx = canvas.getContext("2d");

    // Clear the canvas
    ctx.clearRect(0, 0, width, clampedHeight);

    // Draw the waveform as vertical lines
    ctx.fillStyle = color;

    const centerY = height / 2; // Middle of the canvas
    const totalBars = samples.length; // Total number of bars
    const totalBarWidth = width / totalBars; // Dynamic width per bar (includes spacing)
    const dynamicBarWidth = Math.min(barWidth, totalBarWidth); // Cap bar width to fit spacing

    samples.forEach((amplitude, index) => {
      const x = index * totalBarWidth; // Evenly distribute bars across the canvas width
      const barHeight = amplitude * centerY; // Height of the bar based on amplitude

      // Draw a vertical bar centered on the Y-axis
      ctx.fillRect(x, centerY - barHeight, dynamicBarWidth, barHeight * 2);
    });
  }, [sampleData, theme]);

  return <canvas ref={canvasRef}  />;
};

Waveform.propTypes = {
  track: PropTypes.shape({
    title: PropTypes.string.isRequired, // Track title, used in the file name
    track_type: PropTypes.string.isRequired, // Type of the track (e.g., genre or category)
  }).isRequired,
};

export default Waveform;